const APP_CONFIG = {
  FRONTEND_VERSION: 53,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
